const defaultState = {data: []};

export default (state = defaultState, action) => {
  switch (action.type) {
    case 'LOGOUT':
      return defaultState;
    case 'PUSH_CLAN':
      let clans = state.data;
      clans.push(action.clan);
      return {
        ...state,
        data: clans
      };
    case 'SET_CLANS':
      return {
        ...state,
        data: action.clans
      };
    default:
      return state;
  }
};
